import React from 'react'
import { LazyImage, Notification } from '@offerzen/pinata'

import styles from './styles'

const Introduction = () => (
  <>
    <LazyImage className={styles.image} loader={() => import('../../../../assets/dino-reading.svg')} alt="" width={120} />

    <h1 className={styles.title}>Employer Terms of Use</h1>

    <p className={styles.effectiveDate}>
      <b>Effective Date</b>: <time dateTime="11-09-2023">11 September 2023</time>
    </p>

    <section>
      <h2 id="introduction" data-level="0" className={styles.heading}>Introduction</h2>
      <p>Welcome to OfferZen!</p>
      <p>
        Within these Terms of Use (“<b>Terms</b>”) you will find information about
        OfferZen’s services and your responsibilities when you use our services.
        Please review these terms with care and don’t hesitate to contact us on{' '}
        <a href="mailto:legal@offerzen.com" target="_blank" rel="noreferrer">legal@offerzen.com</a>{' '}
        if you have any questions.
      </p>
      <Notification className={styles.notification} theme="dark">
        <p className={styles.noMargin}>
          💡 These boxes aren’t part of the terms of use, they give you easy to
          understand summaries of each section.
        </p>
      </Notification>
    </section>
  </>
)

export default Introduction
